import { render, staticRenderFns } from "./VerticalLevel.vue?vue&type=template&id=1c877f92&scoped=true&"
import script from "./VerticalLevel.vue?vue&type=script&lang=js&"
export * from "./VerticalLevel.vue?vue&type=script&lang=js&"
import style0 from "./VerticalLevel.vue?vue&type=style&index=0&id=1c877f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c877f92",
  null
  
)

export default component.exports